export const SETCONFIG = "SETCONFIG";
